<template>
  <div class="mainWrapper">
    <div class="pills" v-if="!isIpad">
      <svg
        width="404"
        height="672"
        viewBox="0 0 404 672"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f)">
          <circle
            cx="68.1939"
            cy="336.043"
            r="224.742"
            transform="rotate(-35.648 68.1939 336.043)"
            fill="url(#paint0_linear)"
          />
          <g filter="url(#filter1_i)">
            <rect
              x="247.992"
              y="201.116"
              width="9.71301"
              height="449.484"
              transform="rotate(54.352 247.992 201.116)"
              fill="#196970"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f"
            x="-249.415"
            y="18.4346"
            width="635.218"
            height="635.218"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
          </filter>
          <filter
            id="filter1_i"
            x="-117.265"
            y="201.116"
            width="370.917"
            height="269.854"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="7" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
            />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="68.1939"
            y1="111.301"
            x2="68.1939"
            y2="560.785"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#08455B" />
            <stop offset="1" stop-color="#2A8B84" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        width="122"
        height="227"
        viewBox="0 0 122 227"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M49.3448 147.081L41.1994 143.091C25.3965 135.36 4.97848 120.74 -2.57005 94.9968L-5.47126 85.0809L-51.5646 128.892C-57.0888 134.133 -61.0484 140.788 -63.0143 148.125C-66.7763 162.165 -63.0502 176.831 -53.0548 187.352C-37.3441 203.875 -11.1187 204.539 5.41105 188.834L49.3448 147.081ZM-43.9098 178.659C-50.8615 171.351 -53.4495 161.149 -50.8342 151.388C-49.4706 146.299 -46.7188 141.681 -42.8815 138.025L-11.2495 107.966C-2.09365 128.964 14.4878 142.333 27.7727 150.175L-3.27866 179.699C-14.7676 190.614 -32.995 190.148 -43.9098 178.659Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M45.6576 38.7941L4.44685 77.957L4.58401 78.9238C5.45805 85.0111 7.11416 90.4864 9.24572 95.4989L48.8722 57.7662C50.3777 56.3411 52.7507 56.396 54.1773 57.9035C55.1152 58.881 55.4132 60.2415 55.0866 61.4604C54.9144 62.103 54.573 62.7087 54.0494 63.2083C54.0494 63.2083 13.0815 101.823 12.3879 101.953C24.1072 122.825 44.8873 133.347 55.0867 137.432L56.2117 137.884L100.14 96.118C105.425 91.1009 109.205 84.7389 111.084 77.7288C114.682 64.3012 111.116 50.2833 101.557 40.221C86.5378 24.415 61.4592 23.7795 45.6576 38.7941Z"
          fill="url(#paint1_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="-58.5609"
            y1="131.505"
            x2="46.0106"
            y2="159.524"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#08455B" />
            <stop offset="1" stop-color="#2A8B84" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="7.41025"
            y1="66.8974"
            x2="106.847"
            y2="93.5414"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#08455B" />
            <stop offset="1" stop-color="#2A8B84" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        width="202"
        height="194"
        viewBox="0 0 202 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)" filter="url(#filter0_f)">
          <path
            d="M75.4649 130.288L77.2104 121.387C80.5877 104.122 89.425 80.6157 112.338 66.6614L121.165 61.2927L66.9172 28.1089C60.4249 24.1295 52.9715 22.0273 45.3759 22.0273C30.8405 22.0273 17.6388 29.4223 10.0635 41.8001C-1.83115 61.2521 4.3155 86.7557 23.764 98.6573L75.4649 130.288ZM20.8271 48.3836C26.0863 39.7775 35.2712 34.6371 45.3759 34.6371C50.6445 34.6371 55.818 36.0997 60.3422 38.8601L97.5639 61.6345C79.6512 75.913 71.0295 95.3895 66.893 110.251L30.3382 87.8995C16.822 79.627 12.5538 61.9002 20.8271 48.3836Z"
            fill="url(#paint0_linear)"
          />
          <path
            d="M179.108 98.6997L130.614 69.0293L129.715 69.412C124.062 71.8318 119.201 74.8486 114.911 78.2048L161.614 106.715C163.381 107.8 163.942 110.107 162.855 111.875C162.153 113.034 160.917 113.674 159.655 113.674C158.989 113.674 158.316 113.501 157.698 113.124C157.698 113.124 109.796 83.5467 109.491 82.9103C92.363 99.6323 87.5777 122.428 86.2721 133.337L86.126 134.541L137.839 166.162C144.053 169.968 151.176 171.973 158.434 171.973C172.335 171.973 184.952 164.902 192.198 153.064C203.578 134.465 197.701 110.077 179.108 98.6997Z"
            fill="url(#paint1_linear)"
          />
        </g>
        <defs>
          <filter
            id="filter0_f"
            x="0"
            y="-4"
            width="202"
            height="202"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="62.5824"
            y1="22.0273"
            x2="62.5824"
            y2="130.288"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#08455B" />
            <stop offset="1" stop-color="#2A8B84" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="142.063"
            y1="69.0293"
            x2="142.063"
            y2="171.973"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#08455B" />
            <stop offset="1" stop-color="#2A8B84" />
          </linearGradient>
          <clipPath id="clip0">
            <rect
              width="194"
              height="194"
              fill="white"
              transform="translate(4)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="wrapper">
      <div class="content">
        <div
          class="leftBlog"
          v-for="(item, index) in list.slice(0, 1)"
          :key="index"
        >
          <svg class="svg1">
            <clipPath id="myClipper2" clipPathUnits="objectBoundingBox">
              <path
                d="M0.971,0 H0.185 C0.175,0,0.166,0.015,0.166,0.034 V0.034 C0.166,0.052,0.157,0.068,0.147,0.068 H0.019 C0.009,0.068,0,0.083,0,0.101 V0.949 C0,0.977,0.013,1,0.029,1 H0.971 C0.987,1,1,0.977,1,0.949 V0.051 C1,0.023,0.987,0,0.971,0"
              ></path>
            </clipPath>
          </svg>
          <svg class="svg">
            <clipPath id="myClipper3" clipPathUnits="objectBoundingBox">
              <path
                d="M0.954,0 H0.235 C0.222,0,0.211,0.015,0.211,0.033 V0.033 C0.211,0.051,0.2,0.065,0.187,0.065 H0.031 C0.014,0.065,0,0.084,0,0.106 V0.939 C0,0.973,0.021,1,0.046,1 H0.954 C0.979,1,1,0.973,1,0.939 V0.061 C1,0.027,0.979,0,0.954,0"
              ></path>
            </clipPath>
          </svg>
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url },
              })
            "
          >
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :alt="item.title"
              :thumb="item.image.thumbnail"
            />
            <div class="sub-category">
              <h2>{{ item.sub_category.name }}</h2>
            </div>
            <h1>{{ item.title }}</h1>
            <p>{{ item.brief }}</p>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
          </router-link>
        </div>
        <div class="rightBlog" v-if="!isIpad">
          <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="{ transform: `rotate(${activeIndex * 90}deg)` }"
          >
            <g filter="url(#filter0_d)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M334 633C506.865 633 647 492.865 647 320C647 147.135 506.865 7 334 7C161.135 7 21 147.135 21 320C21 492.865 161.135 633 334 633ZM362 353C449.813 353 521 281.813 521 194C521 106.187 449.813 35 362 35C274.187 35 203 106.187 203 194C203 281.813 274.187 353 362 353Z"
                fill="#FDFFFF"
              />
            </g>
            <g filter="url(#filter1_d)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M334 381C437.277 381 521 297.277 521 194C521 90.7227 437.277 7 334 7C230.723 7 147 90.7227 147 194C147 297.277 230.723 381 334 381ZM362 353C449.813 353 521 281.813 521 194C521 106.187 449.813 35 362 35C274.187 35 203 106.187 203 194C203 281.813 274.187 353 362 353Z"
                fill="#FDFFFF"
              />
            </g>
            <path
              @click="incrementCarousel()"
              class="carouselPointer"
              d="M185.345 192.902L166.844 174.452C166.237 173.848 165.256 173.849 164.651 174.455C164.046 175.062 164.048 176.044 164.654 176.648L182.054 194L164.653 211.352C164.047 211.957 164.046 212.938 164.65 213.544C164.954 213.848 165.351 214 165.748 214C166.145 214 166.541 213.849 166.844 213.547L185.345 195.098C185.637 194.807 185.801 194.412 185.801 194C185.801 193.588 185.636 193.193 185.345 192.902Z"
              fill="#58AABF"
            />
            <g filter="url(#filter2_d)">
              <circle
                cx="362"
                cy="194"
                r="158.5"
                stroke="black"
                stroke-opacity="0.01"
                shape-rendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="14"
                y="0"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_d"
                x="140"
                y="0"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="3.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter2_d"
                x="196"
                y="31"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="3.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <div
            class="images"
            v-for="(item, index) in list.slice(1, 5)"
            :key="index"
            :style="{ transform: `rotate(${activeIndex * 90}deg)` }"
          >
            <div class="mask">
              <div
                class="img-cont"
                :style="{ transform: `rotate(-${activeIndex * 90}deg)` }"
              >
                <router-link
                  :to="
                    $i18nRoute({
                      name: 'NewsDetail',
                      params: { slug: item.url },
                    })
                  "
                >
                  <img
                    v-for="(item, index) in list.slice(1, 5)"
                    :key="index"
                    :src="item.image.medium"
                    alt=""
                    :class="{ active: activeIndex === index }"
                  />
                </router-link>
              </div>
            </div>
          </div>
          <div class="cycle-cont">
            <template v-for="(item, index) in list.slice(1, 5)" :key="index">
              <router-link
                class="cycle-content"
                :class="{ activeContent: activeIndex === index }"
                :to="
                  $i18nRoute({
                    name: 'NewsDetail',
                    params: { slug: item.url },
                  })
                "
              >
                <h2>{{ item.sub_category.name }}</h2>
                <h1>{{ item.title }}</h1>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
              </router-link>
            </template>
          </div>
        </div>
        <div class="rightIpad" v-if="isIpad">
          <div class="ipadLeft">
            <svg class="svg">
              <clipPath id="clip" clipPathUnits="objectBoundingBox">
                <path
                  d="M1,0.058 C1,0.026,0.981,0,0.957,0 H0.426 C0.402,0,0.383,0.026,0.383,0.058 V0.058 C0.383,0.09,0.363,0.116,0.339,0.116 H0.043 C0.019,0.116,0,0.141,0,0.173 V0.942 C0,0.974,0.019,1,0.043,1 H0.957 C0.981,1,1,0.974,1,0.942 V0.058"
                ></path>
              </clipPath>
            </svg>
            <div
              v-for="(item, index) in list.slice(0, 2)"
              :key="index"
              class="ipadContent"
            >
              <router-link
                :to="
                  $i18nRoute({
                    name: 'NewsDetail',
                    params: { slug: item.url },
                  })
                "
              >
                <h3>{{ item.sub_category.name }}</h3>

                <ImageContainer
                  class="img"
                  :src="item.image.medium"
                  :alt="item.title"
                  :thumb="item.image.thumbnail"
                />
                <h1>{{ item.title }}</h1>
                <h2>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h2>
              </router-link>
            </div>
          </div>
          <div
            class="mobileCarousel"
            :class="{ changePosition: carouselPosition }"
          >
            <div class="carouselImages">
              <div
                class="carouselMask"
                v-for="(item, index) in list.slice(1, 5)"
                :key="index"
              >
                <div class="carouselImageCont">
                  <router-link
                    :to="
                      $i18nRoute({
                        name: 'NewsDetail',
                        params: { slug: item.url },
                      })
                    "
                  >
                    <img :src="item.image.medium" alt="" />
                  </router-link>
                </div>
              </div>
            </div>
            <div class="carouselContent">
              <div
                v-for="(item, index) in list.slice(1, 5)"
                :key="index"
                class="carousel-cont"
              >
                <router-link
                  :to="
                    $i18nRoute({
                      name: 'NewsDetail',
                      params: { slug: item.url },
                    })
                  "
                >
                  <h3>{{ item.sub_category.name }}</h3>
                  <h1>{{ item.title }}</h1>
                  <h2>
                    {{ handleDate(item.pub_date) }},
                    {{ handleTime(item.pub_date) }}
                  </h2>
                </router-link>
              </div>
            </div>
            <div class="carouselController" v-if="!isIpad || isMobile">
              <div class="prev" @click="prev()">
                <i class="far fa-angle-left"></i>
                <i class="far fa-angle-left"></i>
              </div>
              <div class="next" @click="next()">
                <i class="far fa-angle-right"></i>
                <i class="far fa-angle-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";

import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const activeIndex = ref(0);
    const carouselPosition = ref(false);
    const isIpad = ref();
    const isMobile = ref();

    const incrementCarousel = (to = 1) => {
      activeIndex.value =
        activeIndex.value + to < 1
          ? activeIndex.value < 3
          : activeIndex.value + to > 3
          ? 0
          : activeIndex.value + to;

      console.log(activeIndex.value);
    };

    const prev = () => {
      carouselPosition.value = true;
    };
    const next = () => {
      carouselPosition.value = false;
    };

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 414;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 414;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      incrementCarousel,
      activeIndex,
      prev,
      next,
      carouselPosition,
      isIpad,
      isMobile,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  position: relative;
  width: 100vw;
  overflow: hidden;
  // pills
  .pills {
    width: 100%;
    height: 100%;
    position: absolute;
    svg {
      position: absolute;
      &:nth-child(1) {
        margin-top: 1.667vw;
      }
      &:nth-child(2) {
        bottom: 0;
        left: 0;
      }
      &:nth-child(3) {
        bottom: 3.906vw;
        right: 0.833vw;
      }
    }
  }
  margin: auto;
  .wrapper {
    position: relative;
    padding-top: 9.219vw;
    padding-bottom: 10.417vw;
    .content {
      display: flex;
      justify-content: space-around;
      .leftBlog {
        width: 43.958vw;
        height: 100%;
        background: var(--left-b-bg);
        backdrop-filter: blur(0.521vw);
        border-radius: 1.302vw;
        display: grid;
        grid-template-areas:
          "leftImage"
          "leftSub"
          "leftTitle"
          "leftContent"
          "leftDate";
        text-align: center;
        padding: 1.563vw;
        cursor: pointer;
        svg {
          position: absolute;
          width: 0;
          height: 0;
        }
        .img {
          width: 40.833vw;
          height: 17.969vw;
          margin-bottom: 0.521vw;
          grid-area: leftImage;
          border-radius: 0.833vw;
          display: flex;
          align-items: center;
        }
        h2 {
          font-size: 0.833vw;
          line-height: 1.146vw;
          font-weight: 400;
          color: var(--light-t-color);
          font-family: "Open Sans", sans-serif;
          font-style: normal;
          grid-area: leftSub;
        }
        h1 {
          font-size: 1.563vw;
          line-height: 1.823vw;
          font-weight: 400;
          color: var(--light-m-color);
          font-family: "Alice", serif;
          font-style: normal;
          padding-left: 6vw;
          padding-right: 6vw;
          margin-bottom: 0.521vw;
          grid-area: leftTitle;
        }
        p {
          font-size: 0.833vw;
          line-height: 1.302vw;
          font-weight: 400;
          color: var(--light-p-color);
          font-family: "Roboto", sans-serif;
          font-style: normal;
          padding-left: 5vw;
          padding-right: 5vw;
          margin-bottom: 0.521vw;
          grid-area: leftContent;
        }
        h3 {
          font-size: 0.781vw;
          line-height: 1.042vw;
          font-weight: 400;
          color: var(--light-b-color);
          font-family: "Open Sans", sans-serif;
          font-style: normal;
          grid-area: leftDate;
        }
      }
      .rightBlog {
        position: relative;
        width: 41.75rem;
        height: 41.75rem;
        background: var(--right-b-bg);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;

        svg {
          width: 100%;
          height: 100%;
          // pointer-events: none;
          transition: all 1s;
          .carouselPointer {
            cursor: pointer;
            stroke: transparent;
            stroke-width: 10vw;
            width: 5vw;
          }
        }

        .images {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          pointer-events: none;
          transition: all 1s;

          .mask {
            width: 19.875rem;
            height: 19.875rem;
            overflow: hidden;
            border-radius: 50%;
            margin-top: 2.2rem;
            margin-left: 12.7rem;
            transition: all 1s;
            .img-cont {
              width: 41.75rem;
              height: 41.75rem;
              top: 0;
              left: 0;
              position: relative;
              margin-top: -2.2rem;
              margin-left: -12.7rem;
              transition: all 1s;
              img {
                transform: scale(0);
                width: 19.875rem;
                height: 19.875rem;
                border-radius: 50%;
                position: absolute;
                pointer-events: all;
                transition: all 1s;
                cursor: pointer;

                &.active {
                  transform: scale(1);
                }

                &:nth-child(1) {
                  top: 2.2rem;
                  left: 12.7rem;
                }

                &:nth-child(2) {
                  right: 2.2rem;
                  top: 12.7rem;
                }

                &:nth-child(3) {
                  bottom: 2.2rem;
                  left: 9.2rem;
                }

                &:nth-child(4) {
                  left: 2.2rem;
                  bottom: 12.7rem;
                }
              }
            }
          }
        }
        .cycle-cont {
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          pointer-events: none;
          .cycle-content {
            opacity: 0;
            position: absolute;
            transition: all 1s;
            h2 {
              color: var(--primary-t-color);
              font-size: 1em;
              line-height: 0.8em;
              margin-bottom: 0.313rem;
              font-family: "Open Sans", sans-serif;
              font-style: normal;
            }
            h1 {
              font-size: 1.375em;
              line-height: 0.9em;
              font-weight: 400;
              margin-bottom: 0.5rem;
              color: var(--primary-m-color);
              font-family: "Alice", serif;
              font-style: normal;
            }
            h3 {
              font-size: 0.938em;
              line-height: 20px;
              font-weight: 400;
              color: var(--primary-b-color);
              font-family: "Open Sans", sans-serif;
              font-style: normal;
            }
            &:nth-child(1) {
              transform: translate(0, 416px);
              width: 395px;
              height: 75px;
              text-align: center;
            }
            &:nth-child(2) {
              transform: translate(-150px, 245px);
              width: 220px;
              height: 178px;
            }
            &:nth-child(3) {
              transform: translate(0, 124px);
              width: 395px;
              height: 75px;
              text-align: center;
            }
            &:nth-child(4) {
              transform: translate(180px, 245px);
              width: 220px;
              height: 178px;
            }
            &.activeContent {
              opacity: 1;
              pointer-events: auto;
              transition: all 1s;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .mainWrapper {
    .wrapper {
      padding-top: 14.583vw;
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .leftBlog {
          position: relative;
          width: 88.281vw;
          height: 100%;
          display: grid;
          padding-bottom: 3.906vw;
          padding-top: 2.604vw;
          grid-template-areas:
            "leftSub"
            "leftImage"
            "leftTitle"
            "leftContent"
            "leftDate";

          .svg2 {
            position: absolute;
            width: 0;
            height: 0;
          }
          .img {
            width: 67.448vw;
            height: 38.542vw;
            border-radius: 1.302vw;
            clip-path: url(#myClipper2);
            margin-left: auto;
            margin-right: auto;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          h1 {
            font-size: 4.167vw;
            line-height: 4.818vw;
            padding: 0 5.599vw;
          }
          p {
            font-size: 3.125vw;
            line-height: 4.557vw;
            font-weight: 400;
            padding: 0 8.333vw;
          }
          h3 {
            font-size: 1.953vw;
            line-height: 2.734vw;
          }
          .sub-category {
            grid-area: leftSub;
            color: var(--light);
            width: max-content;
            position: absolute;
            left: 10vw;
            top: 0;
            h2 {
              font-size: 1.693vw;
              line-height: 2.344vw;
              font-weight: 600;
            }
          }
        }
        .rightIpad {
          display: flex;
          flex-direction: row;
          justify-content: center;
          position: relative;
          width: 100%;
          height: 100%;
          margin-top: 6vw;
          overflow: hidden;

          .ipadLeft {
            display: flex;
            flex-direction: column;
            font-family: "Open Sans", sans-serif;
            position: relative;
            left: 18vw;
            .svg {
              position: absolute;
            }
            .ipadContent {
              display: flex;
              flex-direction: column;
              width: 30vw;
              .img {
                width: 30vw;
                height: 25vw;
                clip-path: url(#clip);
              }
              h3 {
                font-size: 1.8vw;
                line-height: 1.6vw;
                font-weight: 600;
                color: var(--light-b-color);
                margin-bottom: -2vw;
                margin-left: 1vw;
              }
              h1 {
                color: var(--light-m-color);
                font-size: 2.3vw;
                line-height: 1.4em;
                font-weight: 600;
                margin-top: 1vw;
              }
              h2 {
                font-size: 1.8vw;
                line-height: 1.6vw;
                font-weight: 600;
                color: var(--light-b-color);
                margin-top: 1vw;
              }
              &:nth-child(2) {
                margin-bottom: 40vw;
              }
            }
          }
          .mobileCarousel {
            width: 100vw;
            height: 100vw;
            left: 20vw;
            border-radius: 50%;
            display: flex;
            position: relative;
            justify-content: center;
            flex-direction: column;
            box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
            background: var(--right-b-bg);
            .carouselImages {
              width: 90vw;
              height: 90vw;
              box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
              background: var(--right-b-bg);
              border-radius: 50%;
              .carouselMask {
                width: 30vw;
                height: 30vw;
                overflow: hidden;
                border-radius: 50%;
                background: #fdffff;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
                .carouselImageCont {
                  width: 100vw;
                  height: 100vw;
                  position: relative;
                  img {
                    width: 30vw;
                    height: 30vw;
                    position: absolute;
                    border-radius: 50%;
                  }
                }

                &:nth-child(1) {
                  margin-top: -5vw;
                }
                &:nth-child(2) {
                  margin-top: 65vw;
                }
                &:nth-child(3) {
                  opacity: 0;
                }
                &:nth-child(4) {
                  opacity: 0;
                }
              }
            }
            .carouselContent {
              text-align: right;
              position: absolute;
              .carousel-cont {
                position: absolute;
                width: 54vw;
                h3 {
                  font-size: 1.7vw;
                  line-height: 1.6vw;
                  font-weight: 600;
                  font-family: "Open Sans", sans-serif;
                  font-style: normal;
                  color: var(--primary-t-color);
                }
                h1 {
                  font-size: 2.4vw;
                  line-height: 2.4vw;
                  font-weight: 600;
                  font-family: "Source Serif Pro", serif;
                  font-style: normal;
                  color: var(--primary-m-color);
                  margin-top: 1vw;
                  margin-bottom: 1vw;
                }
                h2 {
                  font-size: 2vw;
                  line-height: 2vw;
                  font-weight: 600;
                  font-family: "Open Sans", sans-serif;
                  font-style: normal;
                  color: var(--primary-carousel-b);
                }
                &:nth-child(1) {
                  top: -15vw;
                }
                &:nth-child(2) {
                  top: 7vw;
                }
                &:nth-child(3) {
                  opacity: 0;
                }
                &:nth-child(4) {
                  opacity: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .mainWrapper {
    .wrapper {
      padding-top: 5rem;
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .leftBlog {
          width: 88.164vw;
          text-align: center;
          .img {
            width: 78.986vw;
            height: 59.179vw;
            clip-path: url(#myClipper3);
            display: flex;
            align-items: center;
          }
          h1 {
            font-size: 4.831vw;
            line-height: 5.314vw;
            padding-left: 7.729vw;
          }
          p {
            font-size: 3.382vw;
            line-height: 5.072vw;
            padding: 0 5.072vw;
            margin-top: 3.865vw;
          }
          h3 {
            font-size: 2.899vw;
            line-height: 4.106vw;
          }
          .sub-category {
            margin-bottom: -0.833vw;
            width: max-content;
            position: absolute;
            left: 5.797vw;
            h2 {
              font-size: 2.415vw;
            }
          }
        }
        .rightIpad {
          display: flex;
          justify-content: center;
          position: relative;
          width: 100%;
          height: 100%;
          margin-top: 6vw;
          overflow: hidden;
          .ipadLeft {
            display: none;
          }
          .mobileCarousel {
            width: 100vw;
            height: 100vw;
            left: 32vw;
            border-radius: 50%;
            position: relative;
            box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
            background: var(--right-b-bg);
            transition: all 1s;
            .carouselImages {
              width: 90vw;
              height: 90vw;
              box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
              background: var(--right-b-bg);
              border-radius: 50%;
              transition: all 1s;

              .carouselMask {
                width: 30vw;
                height: 30vw;
                overflow: hidden;
                border-radius: 50%;
                background: #fdffff;
                position: absolute;
                left: 40vw;
                transform: rotate(-12deg);
                box-shadow: 0px 0px 27.3492px 4.10238px rgba(0, 0, 0, 0.25);
                transition: all 1s;

                .carouselImageCont {
                  width: 100vw;
                  height: 100vw;
                  position: relative;
                  transition: all 1s;

                  img {
                    width: 30vw;
                    height: 30vw;
                    position: absolute;
                    border-radius: 50%;
                    transition: all 1s;
                    transform: rotate(-24deg);
                    transition: all 1s;
                  }
                }
                &:nth-child(1) {
                  margin-top: -5vw;
                }
                &:nth-child(2) {
                  margin-top: 65vw;
                }

                &:nth-child(3) {
                  margin-top: -5vw;
                  opacity: 0;
                }
                &:nth-child(4) {
                  margin-top: 65vw;
                  opacity: 0;
                }
              }
            }
            .carouselContent {
              text-align: right;
              position: absolute;
              .carousel-cont {
                position: absolute;
                width: 54vw;
                transition: all 2s;
                opacity: 1;

                h3 {
                  font-size: 1.7vw;
                  line-height: 1.6vw;
                  font-weight: 600;
                  font-family: "Open Sans", sans-serif;
                  font-style: normal;
                  color: var(--primary-t-color);
                }
                h1 {
                  font-size: 2.4vw;
                  line-height: 2.4vw;
                  font-weight: 600;
                  font-family: "Source Serif Pro", serif;
                  font-style: normal;
                  color: var(--primary-m-color);
                  margin-top: 1vw;
                  margin-bottom: 1vw;
                }
                h2 {
                  font-size: 2vw;
                  line-height: 2vw;
                  font-weight: 600;
                  font-family: "Open Sans", sans-serif;
                  font-style: normal;
                  color: var(--primary-carousel-b);
                }
                &:nth-child(1) {
                  left: 10vw;
                  top: -15vw;
                }
                &:nth-child(2) {
                  left: 10vw;
                  top: 7vw;
                }
                &:nth-child(3) {
                  top: -15vw;
                  left: 34vw;
                  opacity: 0;
                  text-align: left;
                }
                &:nth-child(4) {
                  top: 7vw;
                  left: 34vw;
                  text-align: left;
                  opacity: 0;
                }
              }
            }
            .carouselController {
              position: absolute;
              left: 0;

              .prev {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-left: 2vw;
                i {
                  color: rgba(88, 170, 191, 0.4);
                  &:nth-child(1) {
                    font-size: 13vw;
                    font-weight: 300;
                  }
                  &:nth-child(2) {
                    font-size: 10vw;
                    font-weight: 200;
                    margin-left: -2.5vw;
                    margin-top: 0vw;
                  }
                }
              }
              .next {
                display: none;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-left: 9vw;
                i {
                  color: rgba(88, 170, 191, 0.4);
                  &:nth-child(2) {
                    font-size: 13vw;
                    font-weight: 300;
                  }
                  &:nth-child(1) {
                    font-size: 10vw;
                    font-weight: 200;
                    margin-right: -2.5vw;
                  }
                }
              }
            }

            &.changePosition {
              position: relative;
              left: -32vw;
              transition: all 1s;
              .carouselImages {
                // transform: rotate(90deg);
                transition: all 1s;
                transform: translateX(9vw);
                position: relative;
                .carouselMask {
                  transform: rotate(12deg);
                  position: absolute;
                  left: 20vw;
                  transition: all 1s;
                  &:nth-child(1),
                  &:nth-child(2) {
                    opacity: 0;
                  }
                  &:nth-child(3),
                  &:nth-child(4) {
                    opacity: 1;
                  }
                  .carouselImageCont {
                    img {
                      transform: rotate(12deg);
                      transition: all 1s;
                    }
                  }
                }
              }
              .carouselContent {
                .carousel-cont {
                  transition: all 2s;
                  &:nth-child(1),
                  &:nth-child(2) {
                    opacity: 0;
                  }
                  &:nth-child(3),
                  &:nth-child(4) {
                    opacity: 1;
                  }
                }
              }
              .carouselController {
                position: absolute;
                left: 80vw;
                .next {
                  display: flex;
                }
                .prev {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>